// extracted by mini-css-extract-plugin
export default {"buttonsRow":"FormSubmitter_buttonsRow__DJBVR","edit":"FormSubmitter_edit__TOeRd","confirm":"FormSubmitter_confirm__yBELM"};